import React from 'react';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="right" timeout={300} ref={ref} {...props} />
));

export default Transition;
